import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { Routes, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom'

export const initialize = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT_SPECIFIC,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    denyUrls: [/^(http|https):\/\/localhost:.+/g],
    tracesSampleRate: process.env.REACT_APP_ENVIRONMENT === 'production' ? 0.1 : 0.5,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: process.env.REACT_APP_ENVIRONMENT === 'production' ? 0.75 : 0.1,
    ignoreErrors: [
      'Non-Error promise rejection captured with value: Invalid provider.',
      // 'Non-Error promise rejection captured with value: Request failed with status code 401',
      // 'Non-Error promise rejection captured with value: Token is not valid',
      // 'Non-Error promise rejection captured with value: Not Authorized',
      'UnhandledRejection: Non-Error promise rejection captured with value: Invalid provider.',
      /** Error occurs from @floating-ui/react in ui-comp-3 <Select/> when used inside drawer (only when menu height would overflow doc, due to iten count).
       * Per lib's creator, error is harmless and can be ignored:
       * https://github.com/floating-ui/floating-ui/issues/1740#issuecomment-1563544849
       */
      'ResizeObserver loop completed with undelivered notifications.',
    ],
  })
}

export const captureEvent = (error: Sentry.Event) => {
  Sentry.captureEvent(error)
}

export const captureException = (error: Error) => {
  Sentry.captureException(error)
}

export const captureMessage = (message: string) => {
  Sentry.captureMessage(message)
}

export const addBreadcrumb = (breadcrumb: Sentry.Breadcrumb) => {
  Sentry.addBreadcrumb(breadcrumb)
}

export const withScope = (callback: (scope: Sentry.Scope) => void) => {
  Sentry.withScope(callback)
}

export const setUser = (user: Sentry.User | null) => {
  Sentry.setUser(user)
}

export const APMRoutes = Sentry.withSentryReactRouterV6Routing(Routes)
